import { useI18n } from "@/lib/i18n";
import { Twitter } from "lucide-react";

export function Footer() {
  const year = new Date().getFullYear();
  const { t } = useI18n();

  return (
    <footer className="border-t border-border bg-background/80 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-2">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
          <span>
            © {year} Superteam Study · {t("footer.rights")}
          </span>
          <a
            href="https://x.com/Superwhere_"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Follow us on X"
          >
            <Twitter className="h-3.5 w-3.5" />
            <span>@Superwhere_</span>
          </a>
        </div>
      </div>
    </footer>
  );
}

